import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {forkJoin, Subscription} from 'rxjs';
import {IBService} from '../ib.service';

@Component({
  selector: 'fx-ib-network',
  templateUrl: './ib-network.component.html',
  styleUrls: ['./ib-network.component.sass'],
})
export class IbNetworkComponent implements OnInit, OnChanges {
  @Input() ib: any;
  @Input() ibID: any;
  @Output() selectItem = new EventEmitter();
  data: any = [];
  subscription: Subscription;
  selectedItem: any;
  constructor(private service: IBService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ib && this.ib) {
      this.data = [
        {
          root: true,
          email: this.ib.email,
          expanded: true,
          type: 1,
          parentId: this.ib.parentId,
          networkLevel: 1,
          total_asset: this.ib.total_asset,
          total_lot: this.ib.total_lot,
          ib_id: this.ib.ibID,
          text: `${this.ib.firstName || ''} ${this.ib.lastName || ''}`.trim(),
          total_ib: this.ib.totalIb,
          total_trader: this.ib.totalUser,
          user_id: this.ib.userId,
          level: this.ib.level,
          totalChildren: (this.ib.totalUser || 0),
          total_balance: this.ib.totalBalance,
          total_deposit: this.ib.totalDeposit,
          total_withdraw: this.ib.totalWithdraw,
          children: [],
        },
      ];
      this.getData(this.data[0]);
      this.selectItem.emit(this.data[0]);
    }
  }

  getData(item: any): void {
    this.subscription = forkJoin([
      this.service.getIBChildren(item),
      this.service.getUserChildren(item),
    ]).subscribe((data: any) => {
      item.children = [...data[0].data, ...data[1].data];
      item.total_asset = data[1]?.total_asset;
      item.total_lot = data[1]?.total_lot;
    });
  }

  onExpanded(node: any): void {
    if (node.totalChildren) {
      this.getData(node);
    }
  }

  onSelectItem(node: any): void {
    if(node.type===1){
      this.getData(node);
    }
    this.selectedItem = node;
    this.selectItem.emit(this.selectedItem);
  }

  ngOnInit(): void {
  }
}
